<template>
  <div
    :data-component-name="$options.name"
    class="container h-100 d-flex"
    :class="[jel_getClassObject(content), { saviez_vous_que: isSaviezVous }]"
  >
    <img v-if="image" v-lazy="jel_getFichierSrc(image)" class="w-100 image" :alt="content.titre" />
    <div class="div_container" :class="[isSaviezVous ? 'saviez_vous_ctn' : '']">
      <div
        class="mb-1 mt-2 titre_media graphik_bold"
        :style="{ color: content.couleurTitre }"
        v-html="content.titre"
      ></div>
      <div class="texte" v-html="content.texte"></div>
      <!-- TODO: M5 remplacement ici -->
      <!-- <a
        v-if="getMediaImageUrl(content)"
        :href="getMediaImageUrl(content)"
        class="stretched-link" 
      ></a -->
      <b-link
        v-if="!content.lien.field.includes('aucunLien')"
        v-bind="jel_getLienBinding(content.lien)"
      >
        <b-img-lazy :src="jel_getFichierSrc(image)" :alt="content.altImage" />
      </b-link>
    </div>
  </div>
</template>

<script>
import { isJelMobile } from '@/helpers/AppHelpers';

export default {
  name: 'MediaImageTexteSurImage',
  props: { content: { type: Object, required: true } },
  data() {
    return {};
  },
  computed: {
    isSaviezVous() {
      // Fixe rapide pour gerer les borders des saviez-vous-que
      if (this.content.classeCSS && this.content.classeCSS.includes('saviez_vous_que')) {
        return true;
      }
      return false;
    },
    image() {
      if (isJelMobile()) {
        return this.content.imageMobile;
      }
      return this.content.image;
    },
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.row {
  background-position: center;
  background-repeat: no-repeat;
}
.row.bgcover {
  background-size: cover;
}
.container-fluid {
  padding: 0;
}

.image {
  //position: absolute;
  //opacity: 0.5;
  //left: 0;
  height: 100%;
}

.saviez_vous_que {
  border: 2px dashed rgb(13, 203, 143);
  border-radius: ms(2);
}

.div_container.saviez_vous_ctn {
  padding-left: 5%;
  padding-right: 5%;
}

.div_container {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  padding-left: 15%;
  padding-right: 15%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 1;
  align-items: center;
  color: black;
  text-align: center;
  top: 0;
}

.texte {
  @include ms-respond(font-size, 0);
  padding: 0px 5% 0px 5%;
  line-height: 150%;
}
.titre_media {
  @include ms-respond(font-size, 1);
}

.titre_bas .div_container {
  justify-content: flex-end;

  .titre_media {
    @include ms-respond(font-size, 2);
  }
}
</style>
